import Fees from './Fees';

export default Fees;
